import { clearfix } from "../base/clearfix";
import { container, narrowContainer } from "../base/container";
import { gutterMargin } from "../base/margin";
import { textMarginSmall } from "../base/textHelpers";
import { colors, mediaFeatures, medPadding, stdPadding, titleFontSizes } from "../common";
import { splitColors } from "../splitColors";
import { paytm } from "./iconGlyps";
export const offerStrip = `
    ${titleFontSizes};
    ${narrowContainer}
    ${clearfix}
    font-weight: normal;
    padding: calc(${stdPadding} - 2px) calc(${stdPadding} - 2px);
    border: 1px solid ${colors["green"]};
    color: ${colors["green"]};
    background-color: lighten(${colors["green"]}, 65%);
    border-radius: 3px;
    align-items: center;
    line-height: 1.45;
    strong{
        font-weight: bold;
    }
`;
export const offerStripHighlight = `
    color: ${colors["white"]};
    display: inline-block;
    background-color: ${splitColors["insiderBlue"]};
    padding: 5px 9px;
    font-size: 90%;
    border-radius: 3px;
    font-weight: normal;
`;
export const offerStipCta = `
    margin-left: auto;
    font-size: 90%;
`;
export const offerStripLeft = `
    ${textMarginSmall()}
`;
export const offerStripPaytm = `
    border-color: ${colors["paytmBlue"]};
    background-color: #f5fdff;
    color: #0092c2;
    &::before {
        ${paytm}
    }
`;
export const offerStripImage = `
    width: 40px;
    margin: 0 calc(${medPadding} / 2);
    display: inline-block;
    transform: translate(0, 1px);
    img {
        width: 100%;
    }
    @media screen and ${mediaFeatures["for-large-tablet"]} {
        width: 48px;
    }
`;
export const offerStripUnderline = `
    text-decoration: underline;
    margin-left: 5px;
`;
export const offerStripText = `
    padding-right: ${stdPadding};
    @media screen and ${mediaFeatures["for-large-tablet"]} {
        padding-right: calc(${medPadding} / 2);
    }
`;
export const offerStripGroup = `
    ${container}
    ${gutterMargin("bottom")}
`;
export const offerStripFootnote = `
    border-color: ${colors["darkGray"]};
    background-color: transparent;
    color: ${colors["darkGray"]};
`;
export const offerStripCheckout = `
    display: block;
    width: 98%;
    clear: both;
    margin-left: 0;
    margin-bottom: calc(${medPadding} * 2);
    @media screen and ${mediaFeatures["for-tablet"]} {
        width: 100%;
    }
`;
